import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { banUser } from 'features/users/actions';

export function* banUserSaga(action: ReturnType<typeof banUser>) {
  logger
    .remote({ action: true, tier: 1 })
    .info(`The user banned a participant with id=${action.payload.id}`);

  yield call(SignalingSocket.send, {
    event: 'banUser',
    data: {
      id: action.payload.id,
      permanent: action.payload.permanent,
      duration: action.payload.duration,
    },
  });
}
